import { Button } from "@/components/ui/button"
import { ArrowRight, Video, CreditCard, History, MessageSquare } from "lucide-react"

export default function Home() {
  return (
    <div className="flex flex-col min-h-screen">
      <header className="border-b">
        <div className="container mx-auto py-4 px-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold">動画入稿システム</h1>
          <div className="flex gap-4">
            <a href="/login">
              <Button variant="outline">ログイン</Button>
            </a>
            <a href="/register">
              <Button>新規登録</Button>
            </a>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <section className="py-20 bg-gradient-to-r from-blue-50 to-indigo-50">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold mb-6">オンラインで簡単に動画入稿</h2>
            <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
              NEM選択、多言語対応、BGM、ロゴ、背景画像など、様々なカスタマイズオプションを提供します。
            </p>
            <a href="/register">
              <Button size="lg" className="gap-2">
                今すぐ始める <ArrowRight size={16} />
              </Button>
            </a>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold mb-12 text-center">主な機能</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <FeatureCard
                icon={<Video className="h-10 w-10 text-primary" />}
                title="動画入稿"
                description="テキスト、NEM、BGM、ロゴ、背景画像などを選択して動画を作成"
              />
              <FeatureCard
                icon={<CreditCard className="h-10 w-10 text-primary" />}
                title="料金見積もり・決済"
                description="選択したオプションに基づいた料金見積もりと簡単な決済処理"
              />
              <FeatureCard
                icon={<History className="h-10 w-10 text-primary" />}
                title="投稿履歴管理"
                description="過去の投稿内容と状況を確認し、再利用することも可能"
              />
              <FeatureCard
                icon={<MessageSquare className="h-10 w-10 text-primary" />}
                title="サポート"
                description="チャットボットによるサポートで疑問点をすぐに解決"
              />
            </div>
          </div>
        </section>
      </main>

      <footer className="border-t py-8">
        <div className="container mx-auto px-4 text-center text-gray-600">
          <p>© {new Date().getFullYear()} 動画入稿システム. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}

function FeatureCard({ icon, title, description }) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border hover:shadow-md transition-shadow">
      <div className="mb-4">{icon}</div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  )
}
